import { OFFERINGS_CONSTANTS } from "./constants";
import { Box, Heading, Stack, Wrap, WrapItem } from "@chakra-ui/react";
import { AdvantageCard } from "@/components/advantageCard";
import OfferingBgImage from "public/openStack/background.png";
import PageLayout from "@/layouts/pageLayout";

const OfferingsComponent = () => {
  return (
    <Box backgroundImage={OfferingBgImage.src} backgroundSize="cover">
      <PageLayout>
        <Stack spacing={8}>
          <Heading as="h2" fontWeight={"400"} textAlign={"center"} fontSize={"40px"}>
            With MOST, you get:
          </Heading>
          <Wrap spacing={{ base: 8, md: 12 }} justify={"center"} pb={16}>
            {OFFERINGS_CONSTANTS.map((item, index) => (
              <WrapItem
                key={index}
                w={{
                  base: "100%",
                  sm: "280px",
                  md: "360px",
                  lg: "300px",
                  xl: "370px",
                  "2xl": "480px",
                }}
                alignItems={"stretch"}
              >
                <AdvantageCard key={index} {...item} bgColor="white" />
              </WrapItem>
            ))}
          </Wrap>
        </Stack>
      </PageLayout>
    </Box>
  );
};

export default OfferingsComponent;
